import { render, staticRenderFns } from "./segment.vue?vue&type=template&id=27cbeb96&scoped=true&"
import script from "./segment.vue?vue&type=script&lang=js&"
export * from "./segment.vue?vue&type=script&lang=js&"
import style0 from "./segment.vue?vue&type=style&index=0&id=27cbeb96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cbeb96",
  null
  
)

export default component.exports